import { dapiFetch } from "@origin-digital/daxi";
import { config } from "../../config";
import { ICategoryArticleItemDto, IQuickActionDto } from "../../contract";

export interface DefaultSuggestionsResponse {
  faqs: string[];
  quickActions: IQuickActionDto[];
  popularArticles: ICategoryArticleItemDto[];
}

export const fetchDefaultSuggestions =
  async (): Promise<DefaultSuggestionsResponse> => {
    const response = await dapiFetch<{ data: DefaultSuggestionsResponse }>(
      `${config.apiBasePath}/api/search/default-suggestions`,
      { method: "GET" }
    );
    return response.data.data;
  };
